import { useMutation } from '@apollo/client';
import { SYNC_OBJECT_RELATIONSHIPS } from '../mutations/SYNC_OBJECT_RELATIONSHIPS';

const useSyncObjectRelationships = () => {
    return useMutation( SYNC_OBJECT_RELATIONSHIPS );
};

export default useSyncObjectRelationships;
